import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { Modal } from 'antd';
import { RulesImportVisualStore } from '../stores';
import { TestProjectsNavigation } from '../../test_projects/routes';

interface Props {
    store: RulesImportVisualStore;
}

const RulesImportTestProjectUsageWarningDialog: React.FC<Props> = ({ store }: Props) => {
    const onClose = () => {
        store.setTestProjectUsageWarningVisible(false);
    };

    const projectId = store.currentProject?.id;

    const tagEntries = store.getReplacedTagsUsedInTestProjectsWithNames();
    const isFullPackageImport = store.isFullPackageImportWarning;

    return (
        <Modal
            title={isFullPackageImport ? 'Cannot import rule package' : 'Cannot replace tags'}
            className="alpha-portal-dialog"
            visible={store.testProjectUsageWarningVisible}
            onCancel={onClose}
            maskClosable={false}
            closable
            destroyOnClose
            width={600}
            centered
            okText="OK"
            onOk={onClose}
            cancelButtonProps={{ style: { display: 'none' } }}
        >
            <p>
                {isFullPackageImport ? (
                    'Importing this rule package will overwrite all existing rules. The following tags are currently used in test projects and cannot be replaced:'
                ) : (
                    <>
                        The following tags marked as &quot;Replace&quot; are currently used in test projects and cannot
                        be replaced:
                    </>
                )}
            </p>
            <ul>
                {tagEntries.map(({ tagName, testProjects }) => (
                    <li key={tagName}>
                        <strong>{tagName}</strong> — used in {testProjects.length} test projects:{' '}
                        {testProjects.map((tp, index) => (
                            <React.Fragment key={tp.testProjectId}>
                                {index > 0 && ', '}
                                <a
                                    href={
                                        projectId
                                            ? TestProjectsNavigation.TestProjectDashboardPage.replace(
                                                  ':projectId',
                                                  projectId
                                              ).replace(':testProjectId', tp.testProjectId)
                                            : '#'
                                    }
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    {tp.testProjectName}
                                </a>
                            </React.Fragment>
                        ))}
                    </li>
                ))}
            </ul>
            <a
                href={projectId ? TestProjectsNavigation.TestProjectsPage.replace(':projectId', projectId) : '#'}
                target="_blank"
                rel="noopener noreferrer"
            >
                Go to Test Projects
            </a>
            <p style={{ marginTop: '16px' }}>
                {isFullPackageImport ? (
                    'Please remove these tags from the test projects before importing the rule package.'
                ) : (
                    <>
                        Please change the action to &quot;Add&quot; for these tags, or remove them from the test
                        projects first.
                    </>
                )}
            </p>
        </Modal>
    );
};

export default observer(RulesImportTestProjectUsageWarningDialog);
